import type React from "react";
import SendActionModal from "./SendModal";
import GenericRCAModal from "./GenericRCAModal";
import Download from "./DownloadModal";
import EmergencyModal from "./EmergencyModal";
import { ActionModalProps } from "../types/types";

const ActionModal: React.FC<ActionModalProps> = ({
  showModal,
  setShowModal,
  showDownload,
  data,
  setSelectedRowData,
  showRCAModal,
  setShowDownload,
  setShowRCAModal,
  showEmergencyModal = false,
  setShowEmergencyModal,
  onActionComplete,
  mode = "create",
  actionId,
  setRcaId,
  rcaId,
  moduleKey,
  department,
}) => {
  const handleActionComplete = () => {
    setShowModal(false);
    setShowRCAModal(false);
    setShowDownload(false);
    if (setShowEmergencyModal) {
      setShowEmergencyModal(false);
    }
    setSelectedRowData(null);
    if (onActionComplete) onActionComplete();
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setShowRCAModal(false);
    setRcaId(null);
    setSelectedRowData(null);
    setShowDownload(false);
    if (setShowEmergencyModal) {
      setShowEmergencyModal(false);
    }
  };

  const rcaModalKey = rcaId || data?.id || "default";

  const renderRCAModal = () => (
    <GenericRCAModal
      key={`generic-${rcaModalKey}`}
      data={data}
      onActionComplete={handleActionComplete}
      mode={mode}
      rcaId={rcaId || null}
      moduleKey={moduleKey}
    />
  );

  return (
    <>
      {(showModal || showRCAModal || showDownload || showEmergencyModal) && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-[99999] flex items-start justify-end modal-slide"
          role="dialog"
          aria-modal="true"
        >
          <div
            className={`${
              showDownload ? "w-[400px]" : "w-full"
            } max-w-5xl h-full bg-white shadow-2xl flex flex-col overflow-y-auto relative z-[100000]`}
          >
            <div className="flex justify-between items-center px-6 py-2 flex-shrink-0">
              <h2 className="text-xl font-semibold text-[#1b428a]">
                {showRCAModal
                  ? "Root Cause Analysis"
                  : showDownload
                  ? "Download Excel Sheet"
                  : showEmergencyModal
                  ? "Emergency Response"
                  : "Action"}
              </h2>
              <button
                onClick={handleCloseModal}
                className="text-xl font-bold text-gray-600 hover:text-red-500"
              >
                X
              </button>
            </div>

            {showModal ? (
              <SendActionModal
                key={actionId || data?.id || "send-action"}
                data={data}
                onActionComplete={handleActionComplete}
                mode={mode}
                actionId={actionId}
                moduleKey={moduleKey}
              />
            ) : showRCAModal ? (
              renderRCAModal()
            ) : showDownload ? (
              <Download
                key="download-modal"
                onActionComplete={handleActionComplete}
                department={department}
              />
            ) : showEmergencyModal ? (
              <EmergencyModal
                key={data?.id || "emergency-modal"}
                data={data}
                onActionComplete={handleActionComplete}
                mode={mode}
                incidentId={data?.id}
                moduleKey={moduleKey}
              />
            ) : null}
          </div>
        </div>
      )}
    </>
  );
};

export default ActionModal;
